module.exports = __webpack_public_path__ + "img/hp-image.e67baf68.png";